webpackJsonp([53125558880568],{

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-decoration: none;\n  color: rgb(193, 193, 193);\n  font-weight: 900;\n  transition: 0.3s;\n'], ['\n  text-decoration: none;\n  color: rgb(193, 193, 193);\n  font-weight: 900;\n  transition: 0.3s;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _header = __webpack_require__(51);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _caseWrapper = __webpack_require__(30);
	
	var _caseWrapper2 = _interopRequireDefault(_caseWrapper);
	
	var _contentWrapper = __webpack_require__(20);
	
	var _contentWrapper2 = _interopRequireDefault(_contentWrapper);
	
	var _screenImage = __webpack_require__(33);
	
	var _screenImage2 = _interopRequireDefault(_screenImage);
	
	var _leftItem = __webpack_require__(31);
	
	var _leftItem2 = _interopRequireDefault(_leftItem);
	
	var _rightItem = __webpack_require__(32);
	
	var _rightItem2 = _interopRequireDefault(_rightItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject);
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, { title: 'Things I\'ve Done', bgColor: '#C1C1C1', subTitle: 'projects I\'ve worked on' }),
	    _react2.default.createElement(
	      _contentWrapper2.default,
	      null,
	      _react2.default.createElement(
	        _caseWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _leftItem2.default,
	          null,
	          _react2.default.createElement(_screenImage2.default, { src: '/imgs/case-studies/help/overview.png' })
	        ),
	        _react2.default.createElement(
	          _leftItem2.default,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'YouView Help Application'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'An application which users can source help by reading articles and watching videos.'
	          ),
	          _react2.default.createElement(
	            StyledLink,
	            { to: 'case-studies/help-app' },
	            'More about this project'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _caseWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _leftItem2.default,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Benchmark Scaffolding'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Bespoke website built for top UK Scaffolding company.'
	          ),
	          _react2.default.createElement(
	            StyledLink,
	            { to: 'case-studies/benchmark' },
	            'More about this project'
	          )
	        ),
	        _react2.default.createElement(
	          _rightItem2.default,
	          null,
	          _react2.default.createElement(_screenImage2.default, { src: '/imgs/case-studies/bm/bm-home.png' })
	        )
	      ),
	      _react2.default.createElement(
	        _caseWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _leftItem2.default,
	          null,
	          _react2.default.createElement(_screenImage2.default, { src: '/imgs/case-studies/vp/vp-foryou.png' })
	        ),
	        _react2.default.createElement(
	          _leftItem2.default,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Video Previews'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Implementation of video previews and trailers across the UI.'
	          ),
	          _react2.default.createElement(
	            StyledLink,
	            { to: 'case-studies/video-previews' },
	            'More about this project'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _caseWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _leftItem2.default,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Marcus Druen'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Bespoke website built for buiness consultant.'
	          ),
	          _react2.default.createElement(
	            StyledLink,
	            { to: 'case-studies/marcus-druen' },
	            'More about this project'
	          )
	        ),
	        _react2.default.createElement(
	          _rightItem2.default,
	          null,
	          _react2.default.createElement(_screenImage2.default, { src: '/imgs/case-studies/md/md-home.png' })
	        )
	      ),
	      _react2.default.createElement(
	        _caseWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _leftItem2.default,
	          null,
	          _react2.default.createElement(_screenImage2.default, { src: '/imgs/case-studies/st/mysoletrader2.jpg' })
	        ),
	        _react2.default.createElement(
	          _leftItem2.default,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'My SoleTrader'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A bespose CMS which helped user to manage their websites and accounts.'
	          ),
	          _react2.default.createElement(
	            StyledLink,
	            { to: 'case-studies/my-soletrader' },
	            'More about this project'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-studies-index-js-683f4b9ae6315b374b2c.js